import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function ProjectCarousel() {
  const projectImages = [{
    src: 'https://cdn.magicpatterns.com/uploads/vQM6w8FSiBR3ZoYjoaBXdA/Ca_1.webp',
    alt: 'Proyecto Neon Flex 1'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/6WFspb1P6rKRNS86i2Sswm/ca_2.webp',
    alt: 'Proyecto Neon Flex 2'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/cDycxP6HJWvsZH8HtAVifr/ca_3.webp',
    alt: 'Proyecto Neon Flex 3'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/bL5Mo2ofSrV3PoiX5cQHwr/ca_4.webp',
    alt: 'Proyecto Neon Flex 4'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/2xWWQDmhkFTxsCRbznHiZ1/ca_5.webp',
    alt: 'Proyecto Neon Flex 5'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/nPiPTX7X49ahAmHNJdd3JW/ca_6.webp',
    alt: 'Proyecto Neon Flex 6'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/jTzxxtrtUb6HgfRF6cqbL4/ca_7.webp',
    alt: 'Proyecto Neon Flex 7'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/nCjX6GncDjVAkATXmFQGs7/ca_8.webp',
    alt: 'Proyecto Neon Flex 8'
  }];
  const duplicatedImages = [...projectImages, ...projectImages];
  return <section className="py-20 px-4 relative z-10 bg-transparent overflow-hidden border-y border-white/5 pt-[0px] pb-[0px]" data-id="element-163">
      <style data-id="element-164">
        {`
          @keyframes scroll {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          .animate-scroll {
            animation: scroll 40s linear infinite;
          }
          .animate-scroll:hover {
            animation-play-state: paused;
          }
        `}
      </style>

      <div className="max-w-7xl mx-auto px-4 text-center mb-12" data-id="element-165">
        <h2 className="text-4xl md:text-6xl font-black text-white mb-6 tracking-tight" data-id="element-166">
          PROYECTOS QUE <span className="text-[#00f0ff]" data-id="element-167">VAS A LOGRAR</span>
        </h2>
        <p className="text-xl text-gray-400 max-w-2xl mx-auto font-medium" data-id="element-168">
          Desde carteles comerciales hasta piezas de decoración únicas. El
          límite es tu imaginación.
        </p>
      </div>

      <div className="relative w-full overflow-hidden py-10 pt-[45px] pb-[45px]" data-id="element-169">
        <div className="flex w-max animate-scroll gap-8 px-4" data-id="element-170">
          {duplicatedImages.map((image, index) => <div key={index} className="w-80 md:w-[450px] h-64 md:h-80 shrink-0 transition-all duration-500 hover:scale-105 hover:z-20 cursor-pointer group" data-id="element-171">
              <motion.div className="relative w-[300px] h-[200px] md:w-[450px] md:h-[320px] rounded-[2rem] overflow-hidden border border-white/10 shadow-2xl group-hover:border-[#00f0ff]/50 transition-all duration-500" initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} exit={{
            opacity: 0
          }} data-id="element-172">
                <img src={image.src} alt={image.alt} width={450} height={320} loading="lazy" decoding="async" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" data-id="element-173" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1a0b2e]/80 via-transparent to-transparent opacity-60" data-id="element-174" />
              </motion.div>
            </div>)}
        </div>
      </div>
    </section>;
}